import { Injectable } from '@angular/core';
import { AuthenticationService } from './authentication.service';
import { UserService } from './user.service';
import { NavigationService } from './navigation.service';
import { Router } from '@angular/router';
import { User } from '../models';
import { evLog, LoginParams } from '../../../../projects/client/src/app/shared/utils/login-utils';
import { AuthActions } from '../../core/auth/state/auth.actions';
import { Store } from '@ngxs/store';

@Injectable({ providedIn: 'root' })
export class LoginService {
  constructor(
    private router: Router,
    private authenticationService: AuthenticationService,
    private userService: UserService,
    private navigationService: NavigationService,
    private readonly store: Store
  ) {}

  public async login(params: LoginParams, returnUrl?: string) {
    evLog('login: ', { params, returnUrl });

    const user: User = await this.authenticationService.checkLogin(params);
    evLog('login: ', { user });
    this.userService.setUser(user);

    const isAuthenticated = this.userService.isAuthenticated();
    const isAuthenticatedNeedsVerify = this.userService.isAuthenticatedNeedsVerify();
    const twoFactorNeeded = user.twoFactorNeeded;

    evLog('login: ', {
      isAuthenticated,
      isAuthenticatedNeedsVerify,
      twoFactorNeeded
    });

    if (
      !user.mobileVerified &&
      user.mobileVerified !== undefined &&
      this.userService.isIntroducer() &&
      (!user.lastMobileDigits || user.mobile)
    ) {
      return this.navigationService.goToSetupMobileNumber();
    }
    if (this.userService.isAuthenticatedNeedsVerify()) {
      if (twoFactorNeeded.type === 'TWO_FACTOR_SMS') {
        return this.navigationService.goToVerifyMobileNumber();
      } else {
        return this.navigationService.goToVerifyAuthCode();
      }
    }

    if (this.userService.isAuthenticated()) {
      this.store.dispatch(new AuthActions.LoginSuccess(user));
      if (returnUrl) {
        return this.router.navigateByUrl(returnUrl);
      } else {
        return this.navigationService.goToUserDefault();
      }
    }
  }

  public async tryCheckSign() {
    evLog('tryCheckSign: ');

    let user: User;

    try {
      user = await this.authenticationService.checkSigned();
    } catch (e) {
      console.log('Error in tryCheckSign(): ', e);
    }

    evLog('tryCheckSign: ', { user });

    this.userService.setUser(user);
    this.store.dispatch(new AuthActions.SetUser(user));
  }

  public async tryCheckSignAndGoToDefault() {
    evLog('tryCheckSignAndGoToDefault: ');

    const user: User = this.userService.getUser();

    if (!user) {
      await this.tryCheckSign();
    }

    if (this.userService.introducerMobileSetUp()) {
      return this.navigationService.goToSetupMobileNumber();
    }

    if (this.userService.isAuthenticated()) {
      return this.navigationService.goToUserDefault();
    }
  }

  public async logOut() {
    evLog('logOut: ');

    this.userService.closeSession();
    this.store.dispatch(new AuthActions.ClearToken());
    this.store.dispatch(new AuthActions.LogoutSuccess());
    await this.authenticationService.logOut();
  }
}
